import { doNothing, EVENT_POSTPROCESS_DELAY } from "./constants";

/**
 * Slouží k rozlišení pohybu zaměření v rámci potomků komponenty a mimo/do celé komponenty. Využívá vlastnosti událostí zaměření v Reactu, které se propagují nahoru.
 * Využívá timeout s časováním EVENT_POSTPROCESS_DELAY, aby zjistil, jestli se zaměření opravdu přesunulo jinam.
 *
 * @param onFocusHandler Funkce volaná, když komponenta jako celek získá zaměření.
 * @param onBlurHandler Funkce volaná, když komponenta jako celek ztratí zaměření. Do funkce je předán jeden parametr indikující aktuální viditelnost dokumentu
 * (https://developer.mozilla.org/en-US/docs/Web/API/Document/hidden). To umožňuje rozlišit přesun zaměření v rámci stránky a mimo stránku.
 * @param onFocusWithinHandler Funkce volaná, když se změní zaměření v rámci komponenty.
 * @return Vrací objekt s posluchači onFocus a onBlur, které se připojí na komponentu.
 */
export const createFocusWithinObserver = (onFocusHandler: () => void = doNothing, onBlurHandler: (hidden: boolean) => void = doNothing, onFocusWithinHandler: () => void = doNothing) => {
    // Pro timerId nelze použít useState, protože stav není změněn okamžitě. Událost může přijít rychleji, než změna stavu. Potom by měl posluchač nesprávné údaje a
    // nefungoval.
    let timerId: number | undefined = undefined;
    return {
        onFocus: () => {
            if (timerId === undefined) {
                onFocusHandler();
            } else {
                window.clearTimeout(timerId);
                timerId = undefined;
                onFocusWithinHandler();
            }
        },
        onBlur: () => {
            timerId = window.setTimeout(() => {
                timerId = undefined;
                onBlurHandler(document.hidden);
            }, EVENT_POSTPROCESS_DELAY);
        },
    };
};
